export default "__VITE_ASSET__BMozBWRm__"